import React, { createElement } from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { remarkUnderline } from 'utils/remarkUnderline';

import * as Ui from './MarkdownText.styles';

const components = {
  a: ({ children, node, ...props }) =>
    createElement(
      'a',
      {
        ...props,
        target: '_blank',
        rel: 'noopener noreferrer',
        onClick: (event) => event.stopPropagation(),
      },
      children,
    ),
  img: () => null,
};

const MarkdownText = ({ children, className }) => {
  if (!children) {
    return null;
  }

  return (
    <Ui.Container className={className}>
      <ReactMarkdown
        components={components}
        disallowedElements={['img']}
        remarkPlugins={[remarkUnderline]}
        skipHtml
      >
        {children}
      </ReactMarkdown>
    </Ui.Container>
  );
};

MarkdownText.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string,
};

export default MarkdownText;
